import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ConfigProvider, Layout, theme } from 'antd';
import User from './pages/Users';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import Products from './pages/Products/Products';
import Customers from './pages/Customers/Customers';
import HeaderComponent from './components/HeaderComponent/HeaderComponent';
import { NotificationProvider } from './components/NotificationProvider';
import RoleHomeRedirect from './components/RoleHomeRedirect';
import Events from './pages/Events/Events';
import EventDetails from './pages/Events/EventDetails';
import StandDetails from './pages/Stands/StandDetails';
import ProductTypesPage from './pages/ProductTypes/ProductTypePage';
import StandTypesPage from './pages/StandTypes/StandTypesPage';
import CustomerDetailsScreen from './pages/Customers/CustomerDetails';
import ProductDetailsScreen from './pages/Products/ProductDetails';
import OrderDetailsScreen from './pages/Orders/OrderDetails';
import CountriesPage from './pages/Countries/CountryPage';
import { ModalComponent } from './components/Modal';
import SidebarComponent from './components/Sidebar/SidebarComponent';
import EventChecklistPage from './pages/Events/EventChecklistPage';
import Login from './pages/Login/Login';
import ForgotPassword from './pages/Login/ForgotPassword';
import ResetPassword from './pages/Login/ResetPassword';

const { Content } = Layout;

const App: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem('sidebarCollapsed');
    return stored ? stored === 'true' : false;
  });

  const toggleSidebar = () => {
    const newState = !isSidebarCollapsed;
    setIsSidebarCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', newState.toString());
  };

  return (
    <ConfigProvider
      theme={{ algorithm: theme.defaultAlgorithm, token: { colorPrimary: '#00b96b' } }}
    >
      <Router>
        <NotificationProvider>
          <Layout style={{ minHeight: '100vh' }}>
            <HeaderComponent toggleSidebar={toggleSidebar} />
            <Layout>
              <SidebarComponent collapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} />
              <Layout style={{ backgroundColor: '#fff', marginTop: '70px' }}>
                <Content className='content'>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:id" element={<ResetPassword />} />
                    <Route path="/" element={<ProtectedRoute component={RoleHomeRedirect} />} />
                    <Route path="/dashboard" element={<ProtectedRoute component={Dashboard} />} />
                    <Route path="/users" element={<ProtectedRoute component={User} />} />
                    <Route path="/products" element={<ProtectedRoute component={Products} />} />
                    <Route path="/customers" element={<ProtectedRoute component={Customers} />} />
                    <Route path="/events" element={<ProtectedRoute component={Events} />} />
                    <Route path="/events/details/:id" element={<ProtectedRoute component={EventDetails} />} />
                    <Route path="/stands/details/:id" element={<ProtectedRoute component={StandDetails} />} />
                    <Route path="/product-types" element={<ProductTypesPage />} />
                    <Route path="/stand-types" element={<StandTypesPage />} />
                    <Route path="/customers/:customerId" element={<CustomerDetailsScreen />} />
                    <Route path="/products/:productId" element={<ProductDetailsScreen />} />
                    <Route path="/orders/details/:id" element={<ProtectedRoute component={OrderDetailsScreen} />} />
                    <Route path="/my-profile" element={<CustomerDetailsScreen />} />
                    <Route path="/countries" element={<CountriesPage />} />
                    <Route path="/events/:id/checklist" element={<EventChecklistPage />} />
                  </Routes>
                </Content>
              </Layout>
              <ModalComponent />
            </Layout>
          </Layout>
        </NotificationProvider>
      </Router>
    </ConfigProvider>
  );
};

export default App;
